import { PAGE_WIDTH } from '../../constants/layout';
import styles from './PageFrame.module.css';

/**
 * Teacher page skeleton (VIS1 R2): same left edge, title and background on every business page.
 * width: full (lists, dashboards) | narrow (forms: left-aligned under the title, Aside on the right
 * when the shell is wide). Layout reacts to the shell's data-frame, not to the viewport.
 */
export default function PageFrame({ width = PAGE_WIDTH.FULL, children }) {
  return <div className={styles.frame} data-width={width}>{children}</div>;
}

/** Page title + optional subtitle; children = actions, aligned to the frame's right edge.
 *  data-page-header = stable hook for the first-use guides. */
/** `pinActions`: actions stay top-right of the title instead of wrapping under it. */
function Header({ title, subtitle, pinActions = false, children }) {
  return (
    <header className={styles.header} data-page-header="" data-pin-actions={pinActions ? '' : undefined}>
      <div className={styles.heading}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
      </div>
      {children ? <div className={styles.actions}>{children}</div> : null}
    </header>
  );
}

function Body({ children }) {
  return <div className={styles.body}>{children}</div>;
}

function Aside({ children }) {
  return <aside className={styles.aside}>{children}</aside>;
}

PageFrame.Header = Header;
PageFrame.Body = Body;
PageFrame.Aside = Aside;
